












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class StatusLabel extends Vue {
  @Prop() label!: string
  @Prop() labelText!: string
  @Prop() labelClass!: string
  @Prop({ default: false }) tilted!: boolean

  get text() {
    return (this.label && this.label.replace('_', ' ')) || this.labelText
  }
}
